cockpitApp.filter('typeOf', function() {
  return function(object) {
    return typeof object;
  };
});
